module.exports = __webpack_public_path__ + "static/media/SEARCH.a7a2a0bd.png";